import React from "react";
import { Segment, Grid } from "semantic-ui-react";

function ContactoAristas(props) {
  return (
    <Segment color="pink" inverted>
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column floated="left">{`C/ La Alberca, 24 - 30120 El Palmar`}</Grid.Column>
          <Grid.Column floated="right">{`www.grupoaristas.com`}</Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column floated="left">
            {`Tlfo: 968 072 751 (Lunes a Viernes de 9:00h a 19:00h)`}
          </Grid.Column>
          <Grid.Column floated="right">{`escuelas@grupoaristas.com`}</Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}

export default ContactoAristas;



// WEBPACK FOOTER //
// ./src/pages/inscripciones/hojaInscripcion/formularioInscripcion/ContactoAristas.jsx